import React, { Component, } from 'react';
import { arrayOf, object, } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Widget from '../../../../legacy-tv-ui/Widget';
import BarChart from '../../../../legacy-tv-ui/BarChart';
import { toPercentage, } from '../../../../utils';

export class BarChartBlock extends Component {
  static propTypes = {
    data: arrayOf(object),
    stackIds: object,
  }
  static defaultProps = {
    data: [],
    stackIds: {},
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Grid
        item
        xs={5}
        style={{
          padding: 20,
        }}
      >
        <Widget
          title="投資組合權重"
        >
          <BarChart
            formatter={d => toPercentage(d, 0)}
            data={this.props.data}
            stackId={this.props.stackIds}
            barGap={200}
          />
        </Widget>
      </Grid>
    );
  }
}

export default BarChartBlock;



// WEBPACK FOOTER //
// ./src/scenes/Performance/components/BarChartBlock/index.js